import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { getWhatIsMyBusiness } from '../Redux/Actions/UserAction';

// One business per account. Map each business code to its manage page.
const BUSINESS_KEYS = {
  CAR01: 'sp-spare-parts-business',
  CAR02: 'sp-garages-business',
  CAR03: 'sp-car-dealers-business',
  CAR04: 'sp-rent-car-business',
  CAR06: 'sp-car-wash-business',
  CAR07: 'sp-car-insurance-business',
  CAR08: 'sp-driving-school-business',
  CAR09: 'sp-car-protection-business',
  CAR10: 'sp-car-towing',
  CAR11: 'sp-taxi-business',
  CAR12: 'sp-air-conditioning-business',
  CAR13: 'sp-quick-services-business',
};

const BUSINESS_NAMES = {
  CAR01: 'Spare Parts',
  CAR02: 'Garage',
  CAR03: 'Car Dealer',
  CAR04: 'Rent a Car',
  CAR06: 'Car Wash',
  CAR07: 'Car Insurance',
  CAR08: 'Driving School',
  CAR09: 'Car Protection',
  CAR10: 'Car Towing',
  CAR11: 'Taxi',
  CAR12: 'Air Conditioning',
  CAR13: 'Quick Services',
};

/**
 * Guards an "add business" page. Each account may own only ONE business, so if
 * the logged-in user already has a business in a DIFFERENT category, we don't
 * let them fill an add-form that the backend will reject ("already registered").
 * Instead we tell them and send them to their own business's manage page.
 *
 * @param {string} ownCode - the business code this page belongs to (e.g. 'CAR10').
 */
export default function useBusinessGuard(ownCode) {
  const dispatch = useDispatch();
  const getMybusiness = useSelector((state) => state.home?.getMybusiness);
  const redirectedRef = useRef(false);

  useEffect(() => {
    dispatch(getWhatIsMyBusiness());
  }, [dispatch]);

  useEffect(() => {
    if (redirectedRef.current) return;
    const code = getMybusiness?.businessCode;
    const hasBusiness = !!getMybusiness?.businessId;
    if (hasBusiness && code && code !== ownCode) {
      redirectedRef.current = true;
      const route = BUSINESS_KEYS[code] || 'sp-dashboard';
      const name = BUSINESS_NAMES[code] || 'another';
      Swal.fire({
        title: `You already have a ${name} business`,
        text: 'Each account can register only one business. Taking you to your business page.',
        icon: 'info',
        imageUrl: './assets/images/favicon/android-chrome-192x192.png',
        imageHeight: 100,
        confirmButtonColor: '#3ab1f7',
        confirmButtonText: 'Ok',
      }).then(() => {
        window.location.href = `#/${route}`;
      });
    }
  }, [getMybusiness, ownCode]);
}
